<template>
    <div class="content-i">
      <div class="row">
        <div class="col">
          <div class="content-box">
            <div class="row">
              <div class="col-lg">
                <div class="element-wrapper">
                  <h6 class="element-header">Registros Profissionais</h6>

                  <div class="element-box">
                    <form autocomplete="off">
                      <h5 class="form-header">Cadastro de registro de profissionais</h5>
                      <div class="form-desc">
                        Registros de profissionais cadastrados no GrupoSin/DrAchei
                      </div>

                      <div class="row m-2">
                        <div class="col text-right">
                          <a href="#" class="btn btn-secondary" @click="showForm" role="button">
                            <i class="fa fa-plus"></i>
                          </a>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="element-wrapper">
                            <div class="element-box-tp">
                              <div class="table-responsive">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th style="width: 80%" class="text-center">Nome</th>
                                      <th class="text-center">Ação</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="registro in listRegistroProfissional" :key="registro._id">
                                      <td>
                                        {{registro.nome}}
                                      </td>
                                      <td class="text-center">
                                        <a href="#" class="btn btn-primary" @click="edit(registro)" role="button">
                                          <i class="fa fa-edit"></i>
                                        </a>
                                        <a href="#" class="btn btn-primary" @click="remove(registro)" role="button">
                                          <i class="fa fa-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      

                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="modalFormTipoRegistro" tabindex="-1" role="dialog" aria-labelledby="modalTipoRegistroTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <form autocomplete="off" @submit.prevent="save">
              <div class="modal-header">
                <h4 class="modal-title" id="modalTipoRegistroTitleId">Tipo Registro</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="nomeTipoRegistro">Tipo de Registro</label>
                        <input type="text" class="form-control" name="nomeTipoRegistro" id="nomeTipoRegistro"
                          v-model="tipoRegistro.nome">
                      </div>
                    </div>
                  </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button type="submit" class="btn btn-primary">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
export default {
  data () {
    return {
      listRegistroProfissional: [],
      tipoRegistro: {
        nome: ''
      }
    }
  },
  async created () {
    this.listRegistroProfissional = await this.$store.dispatch('getTiposRegistro', '')
  },
  methods: {
    async save () {
      await this.$store.dispatch('saveTipoRegistro', this.tipoRegistro)
      this.$nextTick(() => {
        window.jQuery('#modalFormTipoRegistro').modal('hide')
      })
      this.listRegistroProfissional = await this.$store.dispatch('getTiposRegistro', '')
    },
    showForm () {
      this.tipoRegistro = {
        nome: ''
      }
      this.$nextTick(() => {
        window.jQuery('#modalFormTipoRegistro').modal('show')
      })
    },
    edit (tipoRegistro) {
      this.tipoRegistro = tipoRegistro
      this.$nextTick(() => {
        window.jQuery('#modalFormTipoRegistro').modal('show')
      })
    },
    async remove (tipoRegistro) {
      if (confirm('Deseja realmente remover o registro?')) {
        await this.$store.dispatch('removeTipoRegistro', tipoRegistro)
        this.listRegistroProfissional = await this.$store.dispatch('getTiposRegistro', '')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/tipoRegistro/TipoRegistro.vue